import { useState } from 'react';


export type SortOrderType = "created_at:asc" | "created_at:desc"

export type RequestSortType = {
  sort_order: SortOrderType;
};

export const defaultRequestSort: RequestSortType = {
  sort_order: "created_at:desc", 
};

export const useRequestSort = () => {
  const [sort, setSort] = useState<RequestSortType>(defaultRequestSort);

  const resetSort = () => setSort(defaultRequestSort);

  return { sort, setSort, resetSort };
};